import "reflect-metadata";
import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { wireApplication } from "./ioc/IOCSetup";
import { setupI18n } from "./i18n";
import axios from "axios";
import { AdminConfig } from "./http/Types";
import { fetchLogoUrl } from "./user/UserActions";
import { fetchCurrencies } from "./wallet/WalletActions";
import { createRoot } from "react-dom/client";
import { FeatureFlagProvider } from "./feature-flags/FeatureFlagContext";
import { fliptService } from "./feature-flags/FliptService";
//import './assets/custom-icons/custom/nano-icons.css'

(async function () {
  let config: AdminConfig;
  try {
    config = await getConfig();
  } catch (e) {
    config = { baseUrl: "/rest", integrationBackOffices: {}, enabledPaymentProviders: [] };
  }
  await setupI18n();
  wireApplication(config);

  if (config.fliptUrl && config.fliptEnvironment) {
    // Fire-and-forget — startup is never blocked; flags serve their per-flag defaults until the
    // snapshot loads, then evaluations go live.
    fliptService.init(config.fliptUrl, config.fliptEnvironment);
  } else if (config.fliptUrl || config.fliptEnvironment) {
    console.warn("[FeatureFlags] Both fliptUrl and fliptEnvironment are required. Flipt will not be initialized; flags serve their per-flag defaults.");
  }

  const root = createRoot(document.getElementById("root") as HTMLElement);
  root.render(
    <FeatureFlagProvider>
      <App />
    </FeatureFlagProvider>,
  );

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.unregister();

  await fetchCurrencies();
})();

export async function getConfig(): Promise<AdminConfig> {
  let http = axios.create({
    headers: {
      "Content-type": "application/json",
    },
  });
  return http.get("/config/config.json").then((r) => r.data);
}
